import React, { useState, useEffect } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import { List } from '@phosphor-icons/react';
import Sidebar from './Sidebar';
import Logo from '../Logo';

export default function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer on route change.
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Prevent body scroll while the mobile drawer is open.
  useEffect(() => {
    if (sidebarOpen) {
      const original = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = original;
      };
    }
  }, [sidebarOpen]);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile top bar — replaces the always-visible sidebar on screens < md. */}
      <header
        className="md:hidden sticky top-0 z-20 bg-background/95 backdrop-blur border-b border-border flex items-center gap-3 px-4 h-14"
        data-testid="mobile-topbar"
      >
        <button
          type="button"
          onClick={() => setSidebarOpen(true)}
          className="p-2 -ml-2 rounded-md text-muted-foreground hover:bg-accent"
          aria-label="Åpne meny"
          data-testid="sidebar-open-btn"
        >
          <List size={22} weight="bold" />
        </button>
        <NavLink to="/" className="flex items-center" data-testid="mobile-logo">
          <Logo variant="full" height={24} />
        </NavLink>
      </header>

      <main
        className="md:ml-[240px] p-4 sm:p-6 md:p-8"
        data-testid="main-content"
      >
        {children}
      </main>
    </div>
  );
}
